import { api } from "./api";

const STORE = "ex_clarity_report";
const SESSION = "ex_clarity_session";

export const claritySession = () => {
  let s = sessionStorage.getItem(SESSION);
  if (!s) {
    s = `cs_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    sessionStorage.setItem(SESSION, s);
  }
  return s;
};

// Analytics: event name + question id only — never answers or PII.
export const track = (event, step) =>
  api.post("/clarity/events", { session_id: claritySession(), event, step: step || null }).catch(() => {});

export const savedReport = () => {
  try { return JSON.parse(localStorage.getItem(STORE) || "null"); } catch { return null; }
};
export const saveReport = (assessmentId, token) =>
  localStorage.setItem(STORE, JSON.stringify({ assessmentId, token }));
export const clearReport = () => localStorage.removeItem(STORE);

export const tokenHeader = (token) => ({ headers: { "X-Clarity-Token": token } });

export const advisorHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("exodus_token")}` } });

export const fmtMoney = (n) => (n == null ? "—" : "$" + Math.round(Number(n)).toLocaleString());

export const scoreTone = (s) =>
  s == null ? "text-exodus-muted" : s >= 75 ? "text-exodus-emerald" : s >= 55 ? "gold-text" : "text-orange-300";

export const CATEGORY_ORDER = ["cash", "tax", "protection", "networth", "retirement"];

export const DISCLOSURE =
  "Educational assessment based solely on the information you provide. The Financial Clarity Score is an estimate — not a credit score, actuarial prediction, or guarantee of financial success. Projections use hypothetical assumptions and investment performance is uncertain. Tax treatment depends on applicable law and individual circumstances. Insurance and annuity products have contractual provisions, charges, limitations, and risks. Individualized recommendations require professional review. Exodus Life & Wealth is not affiliated with Financial Scoring AI.";
